import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const CreditsSkeleton: React.FC = () => {
  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Skeleton variant="circular" width={40} height={40} />
      </Box>

      <Grid container spacing={3}>
        {/* Balance Card Skeleton */}
        <Grid item xs={12} md={6}>
          <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
              <Skeleton variant="text" width="30%" height={24} />
            </Box>
            <Skeleton variant="text" width="50%" height={64} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" width="20%" height={24} sx={{ borderRadius: 3 }} />
          </Box>
        </Grid>

        {/* Add Credits Card Skeleton */}
        <Grid item xs={12} md={6}>
          <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Box
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
                <Skeleton variant="text" width="40%" height={24} />
              </Box>
              <Skeleton variant="circular" width={24} height={24} />
            </Box>

            {/* Select Amount Section Skeleton */}
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width="30%" height={20} sx={{ mb: 2 }} />
              <Grid container spacing={1}>
                {[1, 2, 3, 4].map(item => (
                  <Grid item xs={6} key={item}>
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={36}
                      sx={{ borderRadius: 1 }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* Custom Amount Section Skeleton */}
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width="35%" height={20} sx={{ mb: 1 }} />
              <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }} />
            </Box>

            {/* Buy Button Skeleton */}
            <Skeleton variant="rectangular" width="100%" height={48} sx={{ borderRadius: 1 }} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreditsSkeleton;
